import React from "react";
import { useStaticQuery, graphql } from "gatsby";

export const UseFrenchActivitiesData = () => {
  const frenchActivitiesData = useStaticQuery(graphql`
    {
      prismicActivitiesModule(lang: { eq: "fr-fr" }) {
        data {
          activities {
            activity {
              document {
                ... on PrismicActivityCategory {
                  id
                  url
                  data {
                    title {
                      richText
                    }
                    text {
                      richText
                    }
                    thumbnail {
                      alt
                      dimensions {
                        height
                        width
                      }
                      gatsbyImageData(layout: FULL_WIDTH, srcSetMaxWidth: 1000)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return frenchActivitiesData;
};
